/**
 * RugKnots Wishlist
 * Native localStorage-based wishlist — no app required.
 * Persists across sessions. Works on product cards and product pages.
 */
(function () {
  'use strict';
  const STORAGE_KEY = 'rk_wishlist';
  const ICON_EMPTY = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
  const ICON_FILLED = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;

  // --- Storage helpers ---
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function isWishlisted(handle) {
    return getWishlist().includes(handle);
  }
  function toggleWishlist(handle) {
    const list = getWishlist();
    const idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1; // true = added
  }

  // --- Update all buttons for a given handle ---
  function updateButtons(handle) {
    const wishlisted = isWishlisted(handle);
    document.querySelectorAll('.rk-wishlist-btn[data-handle="' + handle + '"]').forEach(function(btn) {
      btn.classList.toggle('rk-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      btn.innerHTML = wishlisted ? ICON_FILLED : ICON_EMPTY;
    });
  }

  // --- Update wishlist count badge ---
  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.rk-wishlist-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // --- Show toast notification ---
  function showToast(added) {
    var toast = document.getElementById('rk-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'rk-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = added ? '\u2665 Added to Wishlist' : 'Removed from Wishlist';
    toast.className = 'rk-wishlist-toast rk-wishlist-toast--show';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() {
      toast.classList.remove('rk-wishlist-toast--show');
    }, 2500);
  }

  // --- Handle button click ---
  function handleClick(e) {
    var btn = e.currentTarget;
    var handle = btn.dataset.handle;
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggleWishlist(handle);
    updateButtons(handle);
    updateCount();
    showToast(added);
  }

  // Track which buttons have already been initialized
  var initializedButtons = new WeakSet();

  // --- Initialize all wishlist buttons ---
  function initButtons() {
    document.querySelectorAll('.rk-wishlist-btn').forEach(function(btn) {
      var handle = btn.dataset.handle;
      if (!handle) return;
      // Set initial state
      var wishlisted = isWishlisted(handle);
      btn.classList.toggle('rk-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      btn.innerHTML = wishlisted ? ICON_FILLED : ICON_EMPTY;
      // Attach click handler only once per button
      if (!initializedButtons.has(btn)) {
        btn.addEventListener('click', handleClick);
        initializedButtons.add(btn);
      }
    });
    updateCount();
  }

  // --- Init on DOM ready ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  // --- Debounced re-init for dynamically loaded product cards ---
  // Only watch for new .rk-wishlist-btn elements, not all DOM changes
  var debounceTimer = null;
  var observer = new MutationObserver(function(mutations) {
    // Only re-init if a new wishlist button was actually added
    var hasNewButton = false;
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('rk-wishlist-btn')) {
            hasNewButton = true;
            break;
          }
          if (node.querySelector && node.querySelector('.rk-wishlist-btn')) {
            hasNewButton = true;
            break;
          }
        }
      }
      if (hasNewButton) break;
    }
    if (!hasNewButton) return;
    // Debounce: wait 300ms after last mutation before re-initializing
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initButtons, 300);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // --- Expose globally for Liquid templates ---
  window.RKWishlist = { getWishlist: getWishlist, isWishlisted: isWishlisted, toggleWishlist: toggleWishlist, updateButtons: updateButtons, updateCount: updateCount };
})();
